import React from 'react';
import { Link } from 'react-router-dom';
import {
    Oem_1
} from '../../../assets/images';

const Oem = () => {
    // Solo una imagen disponible para OEM
    const images = [
        Oem_1
    ];

    // Características destacadas
    const features = [
        {
            title: 'Soluciones Personalizadas',
            description: 'Componentes y sistemas diseñados específicamente para integración en equipos especializados de cualquier sector.'
        },
        {
            title: 'Ingeniería de Precisión',
            description: 'Desarrollados con la más alta calidad y precisión para garantizar un rendimiento óptimo.'
        },
        {
            title: 'Integración Perfecta',
            description: 'Sistemas diseñados para integrarse perfectamente con sus equipos y procesos existentes.'
        },
        {
            title: 'Calidad JCB',
            description: 'Fabricados con los más altos estándares de calidad que caracterizan a JCB.'
        },
        {
            title: 'Soporte Técnico',
            description: 'Asesoría y soporte técnico especializado para la implementación de soluciones OEM.'
        },
        {
            title: 'Versatilidad',
            description: 'Soluciones adaptables a diferentes sectores industriales y requerimientos específicos.'
        }
    ];

    return (
        <div className="container mx-auto px-6 py-24">
            {/* Breadcrumb */}
            <nav className="text-sm mb-8">
                <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
                <span className="mx-2 text-text-muted">/</span>
                <Link to="/industries" className="text-text-muted hover:text-dark-primary">Industrias</Link>
                <span className="mx-2 text-text-muted">/</span>
                <span className="text-dark-primary font-medium">Soluciones OEM</span>
            </nav>

            {/* Hero con imagen */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
                <div>
                    <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-2">
                        Soluciones OEM
                    </h1>
                    <p className="text-text-muted text-lg mb-6">
                        En JCB Azteca ofrecemos soluciones OEM (Original Equipment Manufacturer) diseñadas para satisfacer 
                        las necesidades específicas de cada sector industrial. Desarrollamos componentes y sistemas 
                        personalizados que se integran a la perfección con sus equipos, garantizando el más alto nivel 
                        de calidad, rendimiento y confiabilidad.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 rounded-none transition-all duration-300"
                    >
                        Solicitar información
                    </Link>
                </div>
                <div className="bg-surface-subtle aspect-video rounded-lg flex items-center justify-center overflow-hidden">
                    <img
                        src={images[0]}
                        alt="Soluciones OEM"
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>

            {/* Características Destacadas */}
            <div className="mb-16">
                <h2 className="text-2xl font-display font-bold text-dark-primary mb-8">
                    Características Destacadas
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <div key={index} className="p-6 bg-white border border-border-subtle hover:shadow-md transition-shadow">
                            <h3 className="font-display font-semibold text-dark-primary text-lg mb-2">
                                {feature.title}
                            </h3>
                            <p className="text-text-muted text-sm">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {/* CTA */}
            <div className="bg-surface-subtle p-8 md:p-12 text-center">
                <h2 className="text-2xl font-display font-bold text-dark-primary mb-4">
                    ¿Interesado en Soluciones OEM?
                </h2>
                <p className="text-text-muted mb-6 max-w-2xl mx-auto">
                    Contáctanos para obtener más información, cotizaciones o asesoría técnica sobre nuestras soluciones OEM personalizadas.
                </p>
                <Link
                    to="/contact"
                    className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 transition-all duration-300"
                >
                    Solicitar cotización
                </Link>
            </div>
        </div>
    );
};

export default Oem;